<template>
    <div class="form-group " :class="{'input-group': hasAddon(), 'displayNone': (type === 'hidden')}" v-if="noWrapper">
        <span class="input-group-prepend" style="cursor: pointer" v-if="hasAddon() && addonOnLeft" @click="$emit('addon-click', modelValue)">
            <div class="input-group-text">
                <slot name="addon"></slot>
            </div>
        </span>
        <span class="input-group-prepend" style="cursor: pointer" v-if="hasExtraAddon()" @click="$emit('addon2-click', modelValue)">
            <div class="input-group-text">
                <slot name="addon2"></slot>
            </div>
        </span>
        <input
               slot="input" class="form-control"
               :class="inputClass"
               ref='input'
               @input="updateValue"
               @keyup.enter="updateValue($event, 'enter')"
               @blur="updateValue($event, 'blur')"
               :value="modelValue"
               :data-unmasked-value="unmasked_value"
               :data-is-masked="isMasked"
               :id="id"
               :name="inputName"
               :disabled="disabled"
               :type="type"
               :placeholder="$attrs.placeholder ? $attrs.placeholder : label"
               @change="handleChange"
               :maxlength="maxlength"
               :required="isRequired"
               :readonly="isReadonly"
               v-bind="$attrs"
        />
        <span class="input-group-prepend" :class="addonClass"  style="cursor: pointer" v-if="hasAddon() && !addonOnLeft" @click="$emit('addon-click', modelValue)">
            <div class="input-group-text">
                <slot name="addon"></slot>
            </div>
        </span>
    </div>
    <np-responsive v-else  :class="{'displayNone': (type === 'hidden')}" :split="split">
        <template #label>
        <span>{{label}}
          <span
                  v-if="!!helpText"
                  data-bs-placement="right"
                  data-container="body"
                  data-bs-toggle="popover"
                  :title="label"
                  :data-popover-content="helpText"
                  class="helpBtn addPopover helpHeader">
                <i tabindex="-1" class="fa fa-info-circle"></i>
            </span>
        </span>
        </template>
        <template #input>
        <div class="form-group input-group " :class="{'input-group': hasAddon()}">
             <span class="input-group-prepend" style="cursor: pointer" v-if="hasAddon() && addonOnLeft" @click="$emit('addon-click', modelValue)">
                 <div class="input-group-text">
                     <slot name="addon"></slot>
                 </div>
             </span>
            <span class="input-group-prepend" style="cursor: pointer" v-if="hasExtraAddon()" @click="$emit('addon2-click', modelValue)">
                <div class="input-group-text">
                    <slot name="addon2"></slot>
                </div>
            </span>
            <input class="form-control "
                   ref='input'
                   :class="inputClass"
                   @input="updateValue"
                   @keyup.enter="updateValue($event, 'enter')"
                   @blur="updateValue($event, 'blur')"
                   @change="handleChange"
                   :value="modelValue"
                   :id="id"
                   :data-unmasked-value="unmasked_value"
                   :data-is-masked="isMasked"
                   :name="inputName"
                   :disabled="disabled"
                   :type="type"
                   :placeholder="$attrs.placeholder ? $attrs.placeholder : label"
                   :maxlength="maxlength"
                   :required="isRequired"
                   :readonly="isReadonly"
                   v-bind="$attrs"
            />
            <span class="input-group-prepend" :class="addonClass" style="cursor: pointer" v-if="hasAddon() && !addonOnLeft"
               @click="$emit('addon-click', modelValue)">
                <div class="input-group-text">
                    <slot name="addon"></slot>
                </div>
            </span>
            <span class="input-group-prepend" style="cursor: pointer; margin-left: 2px;" v-if="hasExtraExtraAddon()" @click="$emit('addon3-click', modelValue)">
                <div class="input-group-text">
                    <slot name="addon3"></slot>
                </div>
            </span>
        </div>
        </template>
    </np-responsive>
</template>

<script>

    import NPResponsive from './np-responsive.vue';
    export default {
        name: 'np-input',
        props: {
            id: String,
            name: String,
            label: String,
            split: Number,
            value:{},
            modelValue: {},
            addonOnLeft: {
                default: false
            },
            check_config: {
                default: true
            },
            addonClass: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            disabled: {
                default: false
            },
            type: {
                default: 'text'
            },
            noWrapper: Boolean,
            required: {
                default: true,
            },
            maxlength: {
                default: 50,
            },
            helpText: {
                type: String,
                default :'',
            },
            readonly: false,
            rules: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            inputClass: {
                type: String,
                default: '',
            },
            isMasked: Boolean,
            disableAutocomplete: {
                type: Boolean,
                default: false,
            },
            formatter: Function
        },
        data: function () {
            return {
                default_readonly: false,
                page_config_required: false,
                unmasked_value: '',
                defaultRule: 'alpha_special',
            }
        },
        computed: {
            inputRef: function() {
                return this.$refs.input;
            },
            rulesToAssign(){
                return this.rules.length > 0 ? this.rules : [this.defaultRule]; //default rule to block html tags
            },
            inputName () {
                return !!this.name ? this.name : this.id;
            },
            isReadonly: function () {
                let paths = String(window.location.pathname).split('/');
                let controller =  paths.length > 1 ? paths[1] : '';
                if(!this.readonly) {
                    return (controller === 'application' || controller === 'quote')  ? !!this.default_readonly : !!this.readonly;
                }
                return this.readonly;
            },
            isRequired: function () {
                return !!this.check_config ? !!this.page_config_required : !!this.required;
            },
        },
        mounted: function() {
            $(this.inputRef).on('change keyup', function(){
                $(this).valid();
            })
            this.$nextTick(()=> {
                    if(this.inputRef) {
                        this.assignRules();
                        this.setAutoCompleate();
                    }
            });
            let vm = this;


        },
        methods: {
            assignRules: function () {
                if(this.rulesToAssign.length > 0) {
                    this.rulesToAssign.forEach(rule => {
                        if(typeof rule === 'string') {
                            this.inputRef.setAttribute(`data-rule-${rule}`, '');
                        } else {
                            for (const [key, value] of Object.entries(rule)) {
                                let excluded = ['maxlength', 'minlength', 'min', 'max'];
                                const rule_key = (excluded.findIndex(obj => {return obj === key}) > -1) ? key : `data-rule-${key}`;
                                if(typeof value === 'string') {
                                    this.inputRef.setAttribute(rule_key, `${value}`);
                                } else {
                                    if(value.hasOwnProperty('remove') && value.remove === true) {
                                        if(this.inputRef.hasAttribute(rule_key)) {
                                            this.inputRef.removeAttribute(rule_key)
                                            $(this.inputRef).rules('remove', key)
                                        }
                                    }
                                }
                            }
                        }
                    })
                }
            },
            removeErrorClass: function () {
                let parent = $(this.inputRef).parent();
                parent.removeClass("has-error");
                parent.removeClass("focused-in");
               // $(this.inputRef).tooltip('dispose');
               // $(this.inputRef).tooltip('hide');
              let tooltip = bootstrap.Tooltip.getInstance($(this.inputRef))
              if(tooltip!==null){
                tooltip.dispose()
                tooltip.hide()
              }
            },
            updateValue: function (event, event_type = 'input') {
                let value = event.target.value;

                let $input = $('#' + this.id), vm = this;

                if (value !== '' && this.isMasked && !!$input && !!$input.data('mask') && $input.cleanVal() !== '') {
                    value = $input.masked();
                    this.unmasked_value = $input.cleanVal();
                }

                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
            hasAddon: function() {
                return !!this.$slots.addon;
            },
            hasExtraAddon: function() {
                return !!this.$slots.addon2;
            },
            hasExtraExtraAddon: function() {
                return !!this.$slots.addon3;
            },
            validate: function () {
                $(this).valid();
            },
            handleChange: function(event) {
                if (this.$attrs.type === 'file') {
                    const files = event.target.files;  //return FileList object
                    this.$emit('files', files);
                }
                // this.countCharacters(event)
            },
            countCharacters: function(event) {
                let val = event.target.value;
                let elemLength = val.length;
                let $input = $(this.inputRef);
                let $counter = $input.parent().find('.charCounter');
                let floMaxlengthVal = $input.data('rule-maxlength');

                if(!!floMaxlengthVal && (floMaxlengthVal !== '')) {
                    if($counter.length === 0) {
                        var newNode = document.createElement('div');
                        newNode.classList.add('charCounter');
                        this.inputRef.after(newNode);;
                        $counter = $input.parent().find('.charCounter');
                    }

                    const remainder = floMaxlengthVal - elemLength;
                    $counter.text(remainder);
                    if (remainder === 0) {
                        $counter.css({
                            color: 'rgb(221, 1, 1)'
                        });
                    } else {
                        $counter.css({
                            color: '#fff'
                        });
                    }

                    if(elemLength >= floMaxlengthVal) {
                        // event.preventDefault();

                        // return false;
                    }
                }
            },
            setAutoCompleate: function () {
                if (this.disableAutocomplete === true) {
                    this.inputRef.setAttribute('autocomplete', 'off');
                }
            },
        },
        components: {
            'np-responsive': NPResponsive
        },
        watch: {
            rules: function (val) {
                if(this.required === false  && !this.modelValue) { //prevents error style from disappearing on none required fields with invalid input
                    this.removeErrorClass();
                }
                this.$nextTick(()=> {
                        if(this.inputRef) {
                            this.assignRules();
                            this.setAutoCompleate();
                        }
                });
            },
            required: function (required) {
                if(required === false) {
                    this.removeErrorClass();
                }
            },
            'modelValue': {
                immediate: true,
                handler: function (val, oldVal) {
                    let vm = this;
                    //set unmasked value
                    if (!!val && vm.isMasked) {
                        let $input = $('#' + vm.id);
                        //the clean value may be empty for fields/values that haven't been masked i.e 200
                        if (!!$input && !!$input.data('mask') && $input.cleanVal() !== '') {
                            vm.unmasked_value = $input.cleanVal();
                        } else {
                            vm.unmasked_value = val;
                        }
                    }
                }
            }
        }
    };
</script>
